module.exports = __webpack_public_path__ + "img/code.c1e71541.jpg";